var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29,11.71,6,12H8l.71-.29,1-1L10,10V8l-.29-.71-1-1L8,6H6l-.71.29-1,1L4,8v2l.29.71ZM6,8.41,6.41,8H7.59L8,8.41V9.59L7.59,10H6.41L6,9.59ZM23,2H1L0,3V21l1,1H23l1-1V3ZM2,4H22v9.59L17.41,9h-1.6L4.59,20H2ZM7.45,20l9.15-9L22,16.41V20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/1773309961/media/icon-image.24c6e39b8105eb8debfe134a3c99239b.svg";
export { ForwardRef as ReactComponent };